<template>
  <div class="col-12">
    <div
      v-if="this.$root.$route.query.dev == 'tab'"
      class="row">
      <div class="col-12 text-left">
        <h3 class="design3">
          {{ $t('レンタル申込を受け付けました。') }}

        </h3>
        <p>
          {{ $t('ご利用、ありがとうございます。') }}
        </p>
        <p>
          {{ $t('プリンターから出力されたレシートを受け取り、案内文にしたがって「１．レンタル受付」カウンターへお越しください。') }}<br>
          {{ $t('お客様のレンタルNo.は、以下です。') }}<br>
        </p>
        <p>
          <span
            class="design2"
            style="font-size: 2rem; font-weight: bold;color: red">『{{ this.$root.$store.state.reserveIdShort }}』</span>
        </p>
        <div class="col-12">
          <div class="row">
            <div
              class="col-xs-6 design2"
              style="color: red;font-weight: bold;font-size: 1rem">
              <span>
              {{ $t('message.rentalDate') }}:
              </span>
              <span>
              {{ this.$root.$store.state.rentalDate }}
              </span>
            </div>
          </div>
        </div>
        <p class="text-danger design2">
          {{ $t('レンタルするアイテムを変更する方法がわからない場合はレジ受付時にスタッフにご依頼ください。') }}
        </p>
      </div>
    </div>

    <div
      v-if="this.$root.$route.query.dev != 'tab'"
      class="row">
      <div class="col-12 text-left">
        <template v-if="this.$root.serviceSetting.User.id === '1'">
          <div v-html="$t('message.1.thanks_head')"></div>
          <br>
        </template>
        <template v-else>
          <div v-html="$t('message.thanks_head')"></div>
          <p>
            {{ $t('お客様のレンタルNo.は、以下です。') }}<br>
          </p>
        </template>
        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <span
                style="font-size: 3.5rem; font-weight: bold;color: red">『{{ this.$root.$store.state.reserveIdShort }}』</span>
              <small>
                (<span data-testid="rental_number">{{ this.$root.$store.state.reserveId }}</span>)
              </small>
            </div>
            <div
              class="col-12 col-md-5"
              style="color: red;font-weight: bold;font-size: 1rem">
              <div v-if="willVisitOff === false">
                {{ $t('message.rentalDate') }}: {{ this.$root.$store.state.rentalDate }}
              </div>
              <div v-if="willVisitOff === false">
                {{ $t(this.texts.willVisit) }}:
                <template v-if="this.texts.codeWillVisit === '02'">
                  <span class="thanks-receive-time">{{ willVisitFrom }} {{ $t('message.receiveTimeTo') }} {{ willVisitTo }}</span>
                </template>
                <template v-else>
                  <span class="thanks-receive-time">{{ willVisitFrom }}</span>
                </template>
              </div>
              <div v-if="this.$root.serviceSetting.User.id === '6'">
                受付場所： スキー場センターハウス２Ｆ
              </div>
            </div>
          </div>
        </div>
        <p>
          {{ $t('受付で下記QRコードが必要になりますのでご提示ください。') }}
        </p>
        <p style="font-size: 130%;color: red"><i class="fa fa-exclamation"></i> {{ $t('！この画面のスクリーンショットを必ず撮っていただき、下記「マイページ」URLも保存しておいてください。') }}</p>
        <p class="barcode" style="margin:4rem 0; text-align:center;">
          <img :src="'https://image-charts.com/chart?cht=qr&amp;chl=' + this.$root.$store.state.myPageHash + '&amp;chs=350x350&amp;choe=UTF-8&amp;chld=M|4'"  alt="QRrcode">
        </p>
        <p>
          {{ $t('以下のボタンから受付カウンターのお客様へのご案内状況をご確認いただけます。') }}
        </p>

        <template v-if="this.$root.serviceSetting.User.id === '1'">
          <div style="color: red" v-html="$t('message.1.thanks_notice')"></div>
        </template>
        <template v-else>
          <p class="text-danger font-weight-bold design2">
            <template v-if="this.$root.serviceSetting.User.id === '2'">
              {{ $t('レンタル申込をキャンセルしたい場合は以下の「マイページ (レンタルご案内状況)」ボタンをクリックしてください。') }}<br>
              <span style="display: inline-block;margin-left: 1rem;margin-bottom: 0.8rem;">{{ $t('お客様へのご案内状況をご確認いただけます。') }}</span><br>
              {{ $t('申込済みのアイテムを変更したい場合は、一旦キャンセル処理を行っていただいた後、再度お申し込みください。') }}<br>
              <span style="display: inline-block;margin-left: 1rem;">{{ $t('申込期限を過ぎている場合はレンタル受付時にスタッフに相談してください。') }}</span>
            </template>
            <template v-else>
              <template v-if="willVisitOff === false">
              {{ $t('「受付時間帯指定を変更したい」「レンタル申込をキャンセルしたい」場合は以下の「マイページ (レンタルご案内状況)」ボタンをクリックしてください。') }}<br>
              </template>
              <template v-if="willVisitOff === true">
              {{ $t('「レンタル申込をキャンセルしたい」場合は以下の「マイページ (レンタルご案内状況)」ボタンをクリックしてください。') }}<br>
              </template>
              {{ $t('お客様へのご案内状況をご確認いただけます。') }}<br>
              {{ $t('申込済みのアイテムを変更したい場合はレンタル受付時にスタッフに相談してください。') }}
            </template>
          </p>
        </template>
      </div>
    </div>
    <!-- <div class="row mt-4"> -->

    <div class="row">
      <div class="col-12">
        <!-- <hr> -->
        <!-- <div
          v-if="!isV()"
          class="text-danger mt-2 mb-3"
          style="font-size: 1.5em">
          <small>
            {{ $t('「受付時間帯指定を変更したい」「レンタル予約または申込をキャンセルしたい」場合は「案内状況」をクリックしてください。') }}
          </small>
        </div>
        <div
          v-if="isV()"
          class="text-danger mt-2 mb-3"
          style="font-size: 1.5em">
          <small>
            {{ $t('「レンタル予約または申込をキャンセルしたい」場合は「案内状況」をクリックしてください。') }}
          </small>
        </div>
        <div
          v-if="isV()"
          class="mt-2 mb-3"
          style="font-size: 1.5em">
          <small>
            {{ $t('「事前決済取り置きサービス」を予約いただいたお客様はレンタルされる当日のどの時間帯にお越しいただいてもレンタル可能です。') }}
          </small>
        </div> -->
        <a
          v-if="this.$root.$route.query.dev != 'tab'"
          href="javascript:;"
          :data-url="'/reserve/reserves/view/' + this.$root.$store.state.myPageHash"
          class="mr-4 btn btn-lg btn-block btn-primary design4 btn-3d"
          @click="toView">
          {{ $t('マイページ (レンタルご案内状況)') }} <i class="fas fa-caret-right" /></a>
        <button
          class="btn btn-lg btn-primary btn-block btn-3d mt-4 design4"
          @click="returnStep1()">
          {{ $t('message.backToInit') }} <i class="fas fa-caret-right" />
        </button>
      </div>
    </div>
    <div class="help-block border p-4 mt-4 mb-5 text-left">
      <template v-if="this.$root.serviceSetting.User.id === '1' && this.$parent.$i18n.locale === 'ja'">
        <div v-html="$t('message.1.thanks_bottom')"></div>
      </template>
      <template v-else>
        <strong class="mt-3 mb-2 text-center design2">{{ $t('【お客様ご確認欄】※必ずお読みください') }}</strong><br>
        {{ $t('お受け取りになられたアイテムが申し込み内容と同様である事を必ずご確認下さい。') }}<br>
        {{ $t('アイテム、及びすべてのパーツをチェック頂き不備が無いかをご確認下さい。') }}<br>
        <span>
      {{ $t('レンタル後のアイテムについては、返却まではお客様の管理下にあり、責任は全てお客さま自身となります。') }}<br>
      </span>
        {{ $t('アイテムの紛失、取り違い、破損時には、当スキー場に対して賠償責任が発生することをご了承の上ご利用下さい。') }}<br>
      </template>
      <div v-html="noticeReserveCompleteMessage"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Thanks',
  data () {
    return {
      ui: '',
      reserveId: '',
      openURL: '',
      times: [],
      willVisitOff: false,
      texts: {
        willVisit: '',
        codeWillVisit: '01'
      }
    }
  },
  computed: {
    noticeReserveCompleteMessage () {
      if (this.$root.serviceSetting && this.$root.serviceSetting.notice_reserve_complete.value) {
        var text = ''
        this.$root.serviceSetting.notice_reserve_complete.value.split('\n').forEach(line => { text += this.$t(line) + '<br>' })
        return text
      }
      return null
    },
    noticeReserveConfirmMessage () {
      var text = ''
      if (this.$root.serviceSetting && this.$root.serviceSetting.notice_reserve_confirm.value) {
        console.log(this.$root.serviceSetting.notice_reserve_confirm.value.split('\n'))
        this.$root.serviceSetting.notice_reserve_confirm.value.split('\n').forEach(line => {
          text += this.$t(line) + '<br>'
          console.log(line)
        })
        console.log(text)
        return text
        // return this.$root.serviceSetting.notice_reserve_confirm.value.replace(/\n/g, '<br>')
      }
      return null
    },
    willVisitFrom () {
      let t = this.$root.$store.state.willVisit
      console.log(t, this.times)
      if (t && this.times[t]) {
        let tmp = this.times[t]
        let m = moment(tmp, 'HH:mm')
        return m.format('HH:mm')
      }
      return null
    },
    willVisitTo () {
      let t = this.$root.$store.state.willVisit
      if (t && this.times[t]) {
        let tmp = this.times[t]
        let m = moment(tmp, 'HH:mm')
        return m.add(10, 'minutes').format('HH:mm')
      }
      return null
    }
  },
  created () {
    console.log('scrollTo')
    window.scrollTo({ top: 0 })
  },
  mounted () {
    window.sendGtag({
      'page_path': '/reserve-app/step4'
    })
    if (this.$root.$route.query.dev === 'tab') {
      this.ui = this.$root.$store.state.ui
      this.reserveId = this.$root.$store.state.reserveIdRow

      let openURL = '/reserve/reserves/notification/' + this.ui + '/' + this.reserveId + '/tab'
      let windowReceipt = window.open(openURL, '申込レシート', 'width=10,height=10')

      console.log(openURL)
      let _self = this
      setTimeout(function () {
        if (!windowReceipt.closed) {
          windowReceipt.close()
          _self.$root.$store.commit('initState')
        }
      }, 4 * 1000)
      setTimeout(function () {
        window.sessionStorage.clear()
        location.href = '/reserve-app/?ui=' + _self.$root.$store.state.ui + '&dev=tab'
      }, 30 * 1000)
    }
    this.getEntryTime()
    this.initText()
  },
  methods: {
    getEntryTime () {
      let d = this.$root.$store.state.rentalDateY + '-' + this.$root.$store.state.rentalDateM + '-' + this.$root.$store.state.rentalDateD
      let url = this.$root.baseURL + 'getEntryTime/1.json?d=' + d + '&type=' + this.$root.$route.query.type
      axios.get(url,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        }
      ).then(response => {
        this.times = response.data.times
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    },
    initText () {
      let jsonStr = JSON.parse(this.$root.serviceSetting.entry_time.value)
      if (jsonStr.visible) {
        if (jsonStr.visible === 'false') {
          console.log('willVisitOff')
          this.willVisitOff = true
        } else {
          this.willVisitOff = false
        }
      }
      // console.log('jsonStr', jsonStr)
      // console.log('p.name', jsonStr.name)
      // console.log('p.code', jsonStr.code)
      if (jsonStr.name) {
        this.texts.willVisit = jsonStr.name
      }
      if (jsonStr.code) {
        this.texts.codeWillVisit = jsonStr.code
      }
      return true
    },
    toView (e) {
      let url = e.target.dataset.url
      window.location.href = url
    },
    returnStep1 (e) {
      // ui, int, dev, type は引き継いでリダイレクト
      let resetUrl = '/reserve-app/?ui=' + this.$root.$store.state.userId + '&'
      if (this.$root.$route.query.email !== undefined) {
        resetUrl += '&email=' + this.$root.$route.query.email
      }
      if (this.$root.$route.query.dev !== undefined) {
        resetUrl += '&dev=' + this.$root.$route.query.dev
      }
      if (this.$root.$route.query.type !== undefined) {
        resetUrl += '&type=' + this.$root.$route.query.type
      }
      if (this.$root.$route.query.int !== undefined) {
        resetUrl += '&int=' + this.$root.$route.query.int
      }

      window.sessionStorage.clear()
      console.log('resetUrl', resetUrl)
      window.location.href = resetUrl
    },
    isV () {
      return this.$root.$store.state.reserveIdShort.slice(0, 1) === 'V'
    }
  }

}
</script>
<style scoped>
  .barcode img {
      min-width: 50mm;
      max-width: 50mm;
  }
  .thanks-receive-time {
    font-size: 170%;
    font-weight: bold;
    display: inline-block;
  }
</style>
